import React from "react";

interface Props {
  /** Path from the tree root to the active panel, e.g. ["problem", "costs", "P_gen"]. */
  path: string[];
}

/**
 * VS Code-style breadcrumb bar showing the active panel's location in the tree,
 * e.g. `problem › costs › P_gen`.
 */
const PanelBreadcrumb: React.FC<Props> = ({ path }) => {
  if (path.length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        padding: "3px 10px",
        fontSize: "11px",
        color: "#888",
        background: "#fbfbfb",
        borderBottom: "1px solid #eee",
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
    >
      {path.map((segment, i) => {
        const isLast = i === path.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <span style={{ color: "#bbb" }}>›</span>}
            <span style={{ color: isLast ? "#555" : "#888" }}>{segment}</span>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PanelBreadcrumb;
